import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@morningstar/shared/base/base-component';
import { HelpVideoIconDialogComponent } from './help-video-icon-dialog/help-video-icon-dialog.component';
import { HelpVideoIconService } from './help-video-icon.service';
import { Subject } from 'rxjs';
import { HelpVideo } from 'apps/wsg/src/app/admin/help-video/help-video';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'wsg-help-video-icon',
  templateUrl: './help-video-icon.component.html',
  styleUrls: ['./help-video-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpVideoIconComponent extends BaseComponent {

  @Input() size = '';

  @Input()
  set name(name: string){
    this.helpVideoIconService.getVideo(name).pipe(
      tap(video => this.helpVideo.next(video))
    ).subscribe();
  }

  component = HelpVideoIconDialogComponent;

  helpVideo = new Subject<HelpVideo>();
  helpVideo$ = this.helpVideo.asObservable();

  constructor(private helpVideoIconService: HelpVideoIconService) {
    super(helpVideoIconService);
  }

  getClass(size: string) {
    switch (size) {
      case 'small':
        return 'small-icon';
      case 'md-small':
        return 'md-small-icon';
      default:
        return '';
    }
  }
}
